<template>
    <div class="occupation-private">
        <div class="tab-wrapper w-100">
            <div class="wrapper-nav">
                <ul class="nav nav-pills nav-fill" role="tablist" v-if="numActiveTabs">
                    <li
                        v-for="(tab, index) in activeTabs"
                        :key="`tab-${index}`"
                        class="nav-item">
                        <div
                            class="nav-link nav-label"
                            :class="{'active': selectedTab.id == tab.id}"
                            data-toggle="tab"
                            role="tab"
                            :id="`occupation-item-${tab.id}-tab`"
                            href="javascript:void(0);"
                            :aria-controls="`occupation-item-${tab.id}`"
                            :aria-selected="selectedTab.id == tab.id"
                            @click.prevent="activeTab=tab">
                            <div class="nav-label-content">
                                {{ $t(tab.name) }}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="tab-content">
                <div
                    v-for="(tab) in activeTabs"
                    :key="`tab-pane-${tab.id}`"
                    class="tab-pane fade"
                    :class="{'show active': selectedTab.id == tab.id}"
                    role="tabpanel"
                    :id="`occupation-item-${tab.id}`"
                    :aria-labelledby="`occupation-item-${tab.id}-tab`">
                    <component
                        v-bind:is="tab.component"
                        v-model="tab.model"
                        :panelCfg="panelCfg"
                        :parentId="parentId"
                        :moduleCode="moduleCode"
                        :additional="additional"
                        :baseTranslateID="tab.baseTranslateID"
                        />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import { toCamelCase } from "@config/utils";

export default {
    mixins: [
        CemeteryElementMixin
    ],
    components: {
        OccupationInterments: () => import(/* webpackChunkName: "cemeteries-occupationinterments" */ './OccupationInterments'),
        OccupationDeedOwners: () => import(/* webpackChunkName: "cemeteries-occupationdeedowners" */ './OccupationDeedOwners'),
    },
    props: {
    },
    data() {
        return {
            activeTab: null,
        }
    },
    computed: {
        allowViewInterment() {
            return this.actions?.interment?.show;
        },
        allowViewDeedOwner() {
            return this.actions?.deed_owner?.show;
        },
        tabKeys() {
            return [
                {
                    key: 'interments',
                    default: true,
                    order: 1,
                    model: this.interments,
                    status: this.allowViewInterment && this.interments.length
                },
                {
                    key: 'deed_owners',
                    default: false,
                    order: 2,
                    model: this.deed_owners,
                    status: this.allowViewDeedOwner && this.deed_owners.length
                },
            ];
        },
        tabs() {
            let tabs = [];
            this.tabKeys.forEach((tab, index) => {
                let key = tab.key;
                tabs.push({
                    id: key,
                    name: this.$t(`${this.baseTranslateID}.tabs.${key}`),
                    baseTranslateID: `${this.baseTranslateID}`,
                    component: `Occupation${toCamelCase(key, true)}`,
                    model: tab.model,
                    default: tab?.default ?? false,
                    active: tab?.status ?? true,
                    order: tab.order ?? 1,
                });
            });

            tabs.sort((a,b) => a.order - b.order);
            return tabs;
        },
        activeTabs() {
            return this.tabs.filter(t => t.active);
        },
        numActiveTabs() {
            return this.activeTabs.length;
        },
        selectedTab() {
            return this.activeTab || this.activeTabs.find(t => t.default) || (this.activeTabs.length ? this.activeTabs[0] : {}) || {};
        },
        interments() {
            return this.value?.interments ?? [];
        },
        deed_owners() {
            return this.value?.deed_owners ?? [];
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.occupation-private {
    .wrapper-nav {
        .nav {
            border-bottom: 1px solid rgba(0, 0, 0, .12);

            .nav-item {
                .nav-label {
                    height: 48px;
                    cursor: pointer;
                    box-sizing: border-box;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    white-space: nowrap;
                    position: relative;
                    min-width: 100px;
                    padding: 3px;
                    margin: 3px 3px 0 3px;
                    font-size: 16px;
                    opacity: .6;

                    &.active {
                        opacity: 1;
                        color: inherit;
                        background-color: transparent;
                        border-radius: 0;
                        border-bottom-color: var(--primary-color);
                        border-bottom-width: 2px;
                        border-bottom-style: solid;
                    }

                    .nav-label-content {
                        display: inline-flex;
                        justify-content: center;
                        align-items: center;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}
</style>